import { createStore, combineReducers, applyMiddleware, compose } from 'redux';
import { routerReducer, routerMiddleware } from 'react-router-redux';
import rootReducer from '../../reducers/rootReducer';
import thunkMiddleware from 'redux-thunk';

const history = require('history').createBrowserHistory();
const middleware = routerMiddleware(history)

const composeEnhancers = process.env.NODE_ENV === 'development' && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose

const store = createStore(
    combineReducers({
        router: routerReducer, ...rootReducer
    }),
    composeEnhancers(applyMiddleware(middleware, thunkMiddleware))
)

export { history, store };